import { render, staticRenderFns } from "./AgeTechServiceWrite.vue?vue&type=template&id=a482a4de"
import script from "./AgeTechServiceWrite.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports